
<template>
    <div class="cell-box">

        <div :class="['cell',{'no-border':index==list.length-1}]" v-for="(item,index) in list" @click="goNext(item.url)" :key="item.value">
            <div class="label"><img :src="item.headImg" v-if="item.headImg" alt="">{{item.label}}</div>
            
            <div class="name" v-if="item.value_type=='label'&&item.value"><img :src="item.valueImg" v-if="item.value_type=='labelimg'" alt="">{{item.value}}</div>
            <div class="img" v-if="item.value_type=='img'&&item.value"><img :src="item.value" alt=""></div>
            <div class="placeholder" v-if="!item.value">{{item.placeholder}}</div>
            <div class="arrow-r" v-if="item.url"><img src="../../assets/images/arrow_r.png" alt=""></div>
        </div>
    </div>
</template>

<script type="text/babel">
// 组件
export default {
  name: 'cell',
  data() {
    return {
    };
  },
  props:{
      list:{
          type: Array,
          default: () => {
              return []
          }
      }
  },
  created() {
  },
 mounted() {
 },
  methods: {
      goNext(url) {
          this.$router.push(url)
      }
  }
};
</script>

<style scoped lang="less">
 .cell-box{
     padding: 0 20px;
     background-color: #fff;
     .no-border{
         border-bottom: none;
     }
     .cell{
         padding: 18px 0;
         border-bottom: 1px solid #F1F1F1;
         display: flex;
         align-items: center;
         justify-content:space-between;
        .label{
            font-size: 15px;
            color: #9A9A9C;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img{
                width: 25px;
                height: 25px;
                margin-right: 10px;
            }
        }
        .name{
            flex: 1;
            display: flex;
            justify-content: flex-end;
            font-family: "PingFang-SC-Medium";
            color: #323232;
            font-weight: Medium;
            img{
                width: 20px;
                height: 20px;
            }
        }
        .placeholder{
              flex: 1;
            display: flex;
            justify-content: flex-end;
            font-family: "PingFang-SC-Medium";
            color: #9A9A9C;

        }
        .arrow-r{
            margin-left: 10px;
            img{
                height: 20px;
              width: 10px;
            }
        }
        .img{
            img{

                width: 50px;
                height: 50px;
                border-radius: 50%;
                background-color: cornflowerblue;
            }
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }
     }
 }
</style>
